import UtilService from "@/services/UtilService";
import i18n from "@/i18n";
import TimeService from "@/services/TimeService";
import Room from "@/domain/restaurant/Room";

export default class ClosedPeriod {
  closedPeriodId!: number;
  roomId?: number;
  restaurantId?: number;
  startDate!: string;
  endDate!: string;
  repeatEveryYear!: boolean;
  holidayName!: string;

  constructor(jsonObj?: ClosedPeriod) {
    if (jsonObj) {
      ClosedPeriod.updateClosedPeriod(this, jsonObj);
    }
  }

  static updateClosedPeriod(toUpdate: ClosedPeriod, newVals: ClosedPeriod) {
    toUpdate.closedPeriodId = newVals.closedPeriodId;
    toUpdate.roomId = newVals.roomId;
    toUpdate.restaurantId = newVals.restaurantId;
    toUpdate.startDate = newVals.startDate;
    toUpdate.endDate = newVals.endDate;
    toUpdate.repeatEveryYear = newVals.repeatEveryYear;
    if (newVals.holidayName) toUpdate.holidayName = newVals.holidayName;
  }

  static copy(closedPeriod: ClosedPeriod): ClosedPeriod {
    return new ClosedPeriod(JSON.parse(JSON.stringify(closedPeriod)));
  }

  static haveDifferences(cp1: ClosedPeriod, cp2: ClosedPeriod): boolean {
    return !(JSON.stringify(cp1) === JSON.stringify(cp2));
  }

  static restaurantClosedForHolidayDisplayString(
    closedPeriod: ClosedPeriod,
    date: Date
  ) {
    const startDate = new Date(closedPeriod.startDate);
    const endDate = new Date(closedPeriod.endDate);
    if (closedPeriod.repeatEveryYear) {
      startDate.setUTCFullYear(date.getUTCFullYear());
      endDate.setUTCFullYear(date.getUTCFullYear());
    }
    return (
      i18n.tc("restaurant.closed.holiday") +
      TimeService.getNonISODisplayDateString(startDate) +
      " and " +
      TimeService.getNonISODisplayDateString(endDate) +
      " for " +
      closedPeriod.holidayName
    );
  }

  static roomClosedDisplayString(
    closedPeriod: ClosedPeriod,
    date: Date,
    room: Room
  ) {
    const startDate = new Date(closedPeriod.startDate);
    const endDate = new Date(closedPeriod.endDate);
    if (closedPeriod.repeatEveryYear) {
      startDate.setUTCFullYear(date.getUTCFullYear());
      endDate.setUTCFullYear(date.getUTCFullYear());
    }
    return (
      i18n.tc("room.closed") +
      TimeService.getNonISODisplayDateString(startDate) +
      " and " +
      TimeService.getNonISODisplayDateString(endDate)
    );
  }

  static isActiveOnDate(closedPeriod: ClosedPeriod, date: Date) {
    const startDate = new Date(closedPeriod.startDate);
    const endDate = new Date(closedPeriod.endDate);
    startDate.setUTCHours(0, 0, 0);
    endDate.setUTCHours(0, 0, 0);
    if (closedPeriod.repeatEveryYear) {
      startDate.setUTCFullYear(date.getUTCFullYear());
      endDate.setUTCFullYear(date.getUTCFullYear());
    }
    return (
      TimeService.dateIsAfterOrEqual(date, startDate) &&
      TimeService.dateIsBeforeOrEqual(date, endDate)
    );
  }

  static ClosedPeriodByStartDateAscendingComparator = (
    closedPeriod1: ClosedPeriod,
    closedPeriod2: ClosedPeriod
  ) => {
    const name1 = closedPeriod1.startDate;
    const name2 = closedPeriod2.startDate;
    return UtilService.stringComparatorAscending(name1, name2);
  };
}
